<template>
  <el-dialog title="班组详情" :visible.sync="dialogVisible" width="30%" v-loading="loading" :before-close="handleClose">
    <el-form label-width="110px">
      <el-form-item label="所属项目：">
        <p>{{ info.projectName }}</p>
      </el-form-item>
      <el-form-item label="班组名称：">
        <p>{{ info.teamName }}</p>
      </el-form-item>
      <el-form-item label="班组负责人：">
        <p>{{ info.teamLeader }}</p>
      </el-form-item>
      <el-form-item label="负责人电话：">
        <p>{{ info.teamLeaderPhone }}</p>
      </el-form-item>
      <el-form-item label="所属供应商：">
        <p>{{ info.supplierName }}</p>
      </el-form-item>
      <el-form-item label="合作模式：">
        <p>{{ info.laborModel | cooperationModel }}</p>
      </el-form-item>
      <el-form-item v-if="info.laborModel === '2'" label="劳务单价：" prop="laborPrice">
        <p>{{ info.laborPrice }}元/天</p>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

export default {
  name: 'Detailteams',
  props: {
    id: {
      type: String,
      default: ''
    },
    detailsShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

      loading: false,

      info: {
        // 基础信息
        projectName: '',
        teamName: '',
        teamLeader: '',
        teamLeaderPhone: '',
        supplierName: '',
        cooperationModel: ''
      },
      dialogVisible: false
    }
  },
  filters: {
    cooperationModel: function (value) {
      if (value) {
        if (value === '1') {
          return '包工模式'
        } else {
          return '点工模式'
        }
      }
    }
  },
  watch: {
    detailsShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }

  },
  methods: {
    getDetail () {
      // this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhTeamByTeamId, { teamId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      }).finally(() => {
        // this.loading = false
      })
    },

    handleClose () {
      // console.log('关闭弹窗')
      this.$emit('update:detailsShow', false)
      this.$emit('update:id', '')
      this.info = {
        // 基础信息
        projectName: '',
        teamName: '',
        teamLeader: '',
        teamLeaderPhone: '',
        supplierName: '',
        cooperationModel: ''
      }
    }
  }

}
</script>

<style scoped lang="scss"></style>
